<script>
	import { onMount, onDestroy } from "svelte";
	import * as L from "leaflet";
	const icon = '/images/diamond-plane-teal.png';
	const iconDeleted = '/images/diamond-plane-thick-white.png';

	export let info;
	export let layer;

	let marker;
	let line

	const lastInfo = {}

	$: updateMarker(info)

	onMount(() => {
		updateMarker(info);
	});

	onDestroy(() => {
		if (marker) marker.removeFrom(layer)
		if (line) line.removeFrom(layer)
	});

	function updateMarker(info) {
		let markerInfo = info

		if (Array.isArray(info)) {
			markerInfo = info[info.length - 1]
		}

		if (markerInfo.type === 'PERCEPTO') {
			lastInfo.velocity = markerInfo.velocity.toFixed(2)
			lastInfo.altitude = markerInfo.altitude.toFixed(2)
			lastInfo.onAir = markerInfo.onAir
		}

		const pt = [markerInfo.latitude, markerInfo.longitude]
		if (!marker) {
			marker = L.circleMarker(pt, { radius:6, color:'#ffffff', weight:1, fillColor: '#00a6a6', fillOpacity: 0.5 })
			marker.addTo(layer)
			marker.bindTooltip("")
		}

		/*
		if (!markerInfo.popupE) {
			markerInfo.popupE = document.createElement('div')
			marker.bindTooltip(popupE);
		}
		*/

		let popup = `<h3>Drone ${markerInfo.droneId}</h3>`
		marker.setLatLng(pt);

		if (markerInfo.deleted) {
			marker.setStyle({
				fillColor:'#acacac'
			})
		} else {
			marker.setStyle({
				fillColor:'#00a6a6'
			})
		}
		
		popup += `velocity: ${lastInfo.velocity} m/s<br />altitude: ${lastInfo.altitude} m`
		marker.setTooltipContent(popup)
		
		if (!line && Array.isArray(info)) {
			const pts = info.map(hit => [hit.latitude, hit.longitude])
			line = L.polyline(pts, { color: '#74eaff', opacity: 0.7 }).addTo(layer)
		} else if (line) {
			line.addLatLng(pt)
		}
	}
</script>

<style>
	h3 {
		margin:0;
		margin-bottom:8px;
		padding:0;
	}
	.crap {
		color:#acacac;
	}
</style>